
$(document).ready(function() {
  var elem = document.querySelector("#modalCalificar");
  if (elem == null) {
    return;
  }


  let vueCalificarTerraza = new Vue({
    el: elem,
    data: {
      caracteristicas: [],
      descripcion: "",
      enviando: false
    },
    mounted() {
      this.caracteristicas = caracteristicasJson.map(item => {
        item.calificacion = 0;
        return item
      })
    },
    methods: {
      enviarCalificacion(e){
        let checkCalificacion = this.caracteristicas.filter(item => item.calificacion > 0)
        if(checkCalificacion.length != this.caracteristicas.length){
          swal({
            icon: "info",
            title: "Por favor califica todas las características",
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return;
        }

        if(this.enviando){
          return
        }
        this.enviando = true
        var formData = new FormData(e.srcElement)
        for(let index in this.caracteristicas){
          formData.append("caracteristica[]", JSON.stringify({
            id: this.caracteristicas[index].id,
            calificacion: this.caracteristicas[index].calificacion
          }))
        }
        axios
          .post("/mi-perfil/reservaciones/calificar", formData)
          .then((respuesta) => {
            vueCalificarTerraza.enviando = false
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            swal({
              icon: "success",
              title: "Reseña enviada correctamente",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            }).finally(() =>{
              location.reload()
            })
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueCalificarTerraza.enviando = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      }
    }
  });
});
